import extras from './extras.store';
import {shoppingCartService} from "../../network/services/shopping-cart.service";
import {ResponseError} from "../../network/response/response-error";

export default {
    namespaced: true,
    state: {
        loading: false,
        bookingRoom: null,
        dates: null,
        room_price_id: null,
        price_options: [],
    },
    mutations: {
        SET_LOADING(state, payload) {
            state.loading = !!payload;
        },
        SET_BOOKING_ROOM(state, payload) {
            state.bookingRoom = payload;
            state.room_price_id = payload.booking.room_price.id;
            state.price_options = payload.booking.price_options.map(p => p.id);
        },
        SET_ROOM_PRICE(state, payload) {
            state.room_price_id = payload;
        },
        TOGGLE_OPTIONS(state, payload) {
            const index = state.price_options.indexOf(payload);
            if (index === -1) return state.price_options.push(payload);
            return state.price_options.splice(index, 1);
        },
        REMOVE_EXTRA(state, data) {
            if (!state.bookingRoom) {
                return;
            }
            state.bookingRoom.extras = state.bookingRoom.extras.map(extra => {
                if (extra.extra.id !== data.extra_id || extra.is_option) return extra;
                extra.dates = extra.dates.filter(ed => {
                    return ed.date !== data.date
                });
                return extra;
            }).filter(e => e.dates.length > 0);
        },
        ADD_EXTRA(state, {extra, dates}) {
            if (!state.bookingRoom) {
                return;
            }
            let found = false;
            for (const infos of state.bookingRoom.extras) {
                if (infos.extra.id !== extra.id || infos.is_option) {
                    continue;
                }
                found = true;
            }
            if (!found) {
                state.bookingRoom.extras.push({
                    extra,
                    dates,
                    is_option: false,
                });
                return;
            }
            state.bookingRoom.extras = state.bookingRoom.extras.map(e => {
                if (e.extra.id !== extra.id || e.is_option) {
                    return e;
                }
                e.dates = dates.filter(ed => ed.count > 0).sort((a, b) => (a.date > b.date ? 1 : -1));
                return e;
            }).filter(e => e.dates.length > 0);
        }
    },
    actions: {
        async toggleOption(context, id) {
            if (!context.state.bookingRoom) return;
            context.commit('TOGGLE_OPTIONS', id);
            await context.dispatch('commit');
            context.commit('SET_LOADING', true);
            const response = await shoppingCartService.updateBookingRoom(context.state.bookingRoom.id, {
                price_options: context.state.price_options
            });
            if (response instanceof ResponseError) {
                context.commit('SET_LOADING', false);
                console.error('An error occured');
                return;
            }
            return context.dispatch('fetch', context.state.bookingRoom.id);
        },
        async fetch(context, id) {
            shoppingCartService.setAuth(context.rootState.client.tokens.accessToken);
            id = parseInt(id);
            context.commit('SET_LOADING', true);
            const uuid = context.rootState.shoppingCart.uuid;
            const lang = context.rootState.lang.currentLang;
            shoppingCartService.setUuid(uuid);
            const response = await shoppingCartService.fetchBookingRoom(id, lang);
            if (response instanceof ResponseError) {
                context.commit('SET_LOADING', false);
                console.error('An error occured');
                return;
            }
            context.commit('SET_BOOKING_ROOM', response.get('ShoppingCart.bookingRoom', null));
            await context.dispatch('extras/fetch', {
                room_id: response.get('ShoppingCart.bookingRoom.room.id'),
                lang
            });
            context.commit('SET_LOADING', false);
        },
        async commit(context) {
            shoppingCartService.setAuth(context.rootState.client.tokens.accessToken);
            if (!context.state.bookingRoom) return;
            if (!context.state.bookingRoom.extras) context.state.bookingRoom.extras = [];
            const extrasToAddOrUpdate = context.state.bookingRoom.extras
                .filter(e => e.is_option === undefined || e.is_option === false)
                .map(e => ({
                    id: e.extra.id,
                    dates: e.dates.map(s => ({
                        date: s.date,
                        count: s.count
                    }))
                }));
            const data = {
                sc_booking_room_id: context.state.bookingRoom.id,
                extras: extrasToAddOrUpdate
            }
            context.commit('SET_LOADING', true);
            const response = await shoppingCartService.commitBookingRoomState(data);
            const inserted = response.get('ShoppingCart.bookings.extras.setExtras.inserted', false);
            if (inserted instanceof ResponseError) {
                // TODO catch errors
            } else if (inserted === false) {
                // TODO catch errors
            }
            context.dispatch('shoppingCart/init', {lang: 'FR'}, {root: true});
            context.commit('SET_LOADING', false);
        },
        async delete({commit, dispatch, rootState}, {id}) {
            shoppingCartService.setAuth(rootState.client.tokens.accessToken);
            commit('SET_LOADING', true);
            const response = await shoppingCartService.deleteBookingRoom({id});
            const deleted = response.get('ShoppingCart.bookings.deleteRoom.deleted', false);
            if (deleted instanceof ResponseError) {
                // TODO catch errors
            } else if (deleted === false) {
                // TODO catch errors
            } else {
                dispatch('shoppingCart/init', {lang: 'FR'}, {root: true});
            }
            commit('SET_LOADING', false);
        },
    },
    modules: {
        extras,
    }
}



// WEBPACK FOOTER //
// ./src/stores/shopping-cart/booking-room.store.js